module.exports = __webpack_public_path__ + "media/images/river/insanely-soft-a868d2c1e833e64a6ef40caf0a9d066c.jpg";